import * as actionType from "../types/ActionTypes";
import axios from "../../shared/axios";
import Swal from "sweetalert2";
import { baseUrl } from "../../shared/baseURL";

export const batchesSetData = (batches) => {
  return {
    type: actionType.BATCHES_SET_DATA,
    batches: batches,
  };
};

export const batchesFailData = (error) => {
  return {
    type: actionType.BATCHES_FAIL_DATA,
    error: error,
  };
};

export const batchesLoading = () => {
  return {
    type: actionType.BATCHES_LOADING,
  };
};

export const batchesGetData = () => {
  return (dispatch) => {
    dispatch(batchesLoading());
    axios
      .get(baseUrl + "/batches", {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          // Authorization: "Bearer " + data.token,
        },
      })
      .then((res) => {
        dispatch(batchesSetData(res.data));
      })
      .catch((error) => dispatch(batchesFailData(error)));
  };
};

export const deleteBatchesFail = (error) => {
  return {
    type: actionType.DELETE_BATCHES_FAIL,
    error: error,
  };
};

export const deleteBatches = (id, data) => {
  return (dispatch) => {
    if (id) {
      axios
        .delete(baseUrl + `/batches/${data.id}`, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + data?.token,
          },
        })
        .then(() => {
          Swal.fire("Deleted!", "Your file has been deleted.", "success").then(
            () => {
              dispatch(batchesGetData(data));
            }
          );
        })
        .catch((error) => dispatch(deleteBatchesFail()));
    }
  };
};

export const postBatchesDataStart = () => {
  return {
    type: actionType.POST_BATCHES_DATA_START,
  };
};

export const postBatchesDataFail = (error) => {
  return {
    type: actionType.POST_BATCHES_DATA_FAIL,
    error: error,
  };
};

export const postBatchesDataSuccess = (success) => {
  return {
    type: actionType.POST_BATCHES_DATA_SUCCESS,
    success: success,
  };
};

export const batchesPostLoading = () => {
  return {
    type: actionType.BATCHES_POST_LOADING,
  };
};

export const postBatchesData = (data, batches, toggle, setSubmitting) => {
  return (dispatch) => {
    dispatch(postBatchesDataStart());
    dispatch(batchesPostLoading());
    axios
      .post(baseUrl + "/batches", batches, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + data.token,
        },
      })
      .then((res) => {
        dispatch(postBatchesDataSuccess(res.data));
        dispatch(batchesGetData(data));
        Swal.fire({
          position: "success",
          icon: "success",
          title: "Successfully Created",
          showConfirmButton: false,
          timer: 1500,
        }).then(() => {
          if (toggle) {
            toggle();
          }
          if (setSubmitting) {
            setSubmitting(false);
          }
        });
      })
      .catch((error) => {
        if (setSubmitting) {
          setSubmitting(false);
        }
        dispatch(postBatchesDataFail(error));
      });
  };
};

export const updateBatchesDataStart = () => {
  return {
    type: actionType.UPDATE_BATCHES_DATA_START,
  };
};

export const batchesUpdateLoading = () => {
  return {
    type: actionType.BATCHES_UPDATE_LOADING,
  };
};

export const updateBatchesDataFail = (error) => {
  return {
    type: actionType.UPDATE_BATCHES_DATA_FAIL,
    error: error,
  };
};

export const updateBatchesDataSuccess = (success) => {
  return {
    type: actionType.UPDATE_BATCHES_DATA_SUCCESS,
    success: success,
  };
};

export const updateBatchesData = (data, batches, toggle, setSubmitting) => {
  return (dispatch) => {
    dispatch(updateBatchesDataStart());
    dispatch(batchesUpdateLoading());

    axios
      .put(baseUrl + `/batches/${data.id}`, batches, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + data.token,
        },
      })
      .then((res) => {
        dispatch(updateBatchesDataSuccess(res.data));
        dispatch(batchesGetData(data));
        Swal.fire({
          position: "success",
          icon: "success",
          title: "Successfully Updated !",
          showConfirmButton: false,
          timer: 1500,
        }).then(() => {
          if (toggle) {
            toggle();
          }
          if (setSubmitting) {
            setSubmitting(false);
          }
        });
      })
      .catch((error) => {
        if (setSubmitting) {
          setSubmitting(false);
        }
        dispatch(updateBatchesDataFail(error));
      });
  };
};
